var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content" },
    [
      _c(
        "Titlebar",
        { attrs: { incrustation: "fa-user-circle", backPath: "/reports" } },
        [_c("h1", [_vm._v(_vm._s(_vm.$t("reports.reports.logs.title")))])]
      ),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c(
            "UiTabs",
            { staticClass: "mb-4", on: { input: _vm.handleChange } },
            [
              _c("UiTab", {
                attrs: {
                  title: "Licences",
                  active: _vm.historyType === "licence",
                },
              }),
              _vm._v(" "),
              _c("UiTab", {
                attrs: {
                  title: "Profils",
                  active: _vm.historyType === "profile",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("SuperTable", {
            ref: "tableIdentifications",
            attrs: {
              tableColumns: _vm.tableColumns,
              tableData: _vm.tableData ? _vm.tableData : [],
              loading: !_vm.tableData,
            },
            on: { sort: _vm.handleSort, filter: _vm.handleFilter },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "float-right" },
              [
                _c(
                  "Button",
                  {
                    staticClass: "default",
                    nativeOn: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.downloadReport($event)
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("i", { staticClass: "fa fa-download" }),
                      _vm._v(
                        "   " + _vm._s(_vm.$t("reports.logsTable.download"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("LoadingMini", { ref: "loading" }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }